import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PeopleConnectingPlugIcon } from 'assets';

import StyledButton from '../StyledButton/StyledButton';

import styles from './ErrorNotification.module.css';

const ErrorNotification = () => {
   const navigate = useNavigate();
   const { t } = useTranslation();

   const handleReloadPage = () => navigate(0);

   return (
      <div className={styles.container}>
         <PeopleConnectingPlugIcon />
         <h2>{t('errorNotification.title')}</h2>
         <p>
            {t('errorNotification.description.line1')}
            <br />
            {t('errorNotification.description.line2')}
         </p>
         <StyledButton
            variant="filled-primary"
            text={t('errorNotification.refreshButton')}
            onClick={handleReloadPage}
         />
      </div>
   );
};

export default ErrorNotification;
